const Deal = require('./Deal');
const { DEAL_STATUS } = require('../constants/DealConstants');
const { dealSupplierExtractor } = require('../utils/DealSupplier');

function isValidDeal(deal) {
  if (!deal || !deal.id) {
    //console.error('invalid deal received: ', deal);
    return false;
  }
  return true;
}

function isValidRecheck(recheck) {
  return recheck && recheck.recheck_id && recheck.chooseprod && recheck.cheapopoPricing;
}

function createDeal(deal, idx) {
  return new Deal(deal, idx + 1); // 1 based
}

function createDeals(deals) {
  if (!Array.isArray(deals)) {
    // console.error('invalid deals received: ', deals);
    return [];
  }

  return deals.filter(isValidDeal).map(createDeal);
}

function updateDealRecheck(deal, recheck) {
  deal.setRecheck(recheck.recheck_id, recheck.chooseprod, recheck.cheapopoPricing, recheck.installments_eligibility);
  deal.status = DEAL_STATUS.SUCCESS;
  if (deal.error) {
    deal.error = false;
  }
  return deal;
}

function compareByPrice(dealA, dealB) {
  return dealA.totalPrice - dealB.totalPrice;
}

module.exports = {
  dealSupplierExtractor,
  isValidDeal,
  isValidRecheck,
  createDeal,
  createDeals,
  updateDealRecheck,
  compareByPrice
};
